import { useCallback } from 'react';
import { ApiLoader, useApiResource } from './apiHelpers';

export interface PersonalField {
  NAME: string;
  ANCHOR: string;
  AVERAGE_LENGTH: number;
}

export type PersonalFieldsByCategory = { [category: string]: PersonalField[] };

export type PersonalFieldsChannel = 'SMS' | 'EMAILING' | 'CASHDESK';

type EssentialDatasResponse = Record<string, {
  PERSONAL_FIELDS?: Partial<Record<PersonalFieldsChannel, PersonalFieldsByCategory>>;
} | undefined>;

const EMPTY_FIELDS: PersonalFieldsByCategory = {};

const useGetPersonalFields = (channel: PersonalFieldsChannel) => {
  const load = useCallback<ApiLoader<PersonalFieldsByCategory>>(
    async (authFetch, workspaceId) => {
      const result: EssentialDatasResponse | null = await authFetch('/getEssentialDatasWorkspace', {
        method: 'POST',
        body: JSON.stringify({ workspace: workspaceId }),
      });
      return result?.[workspaceId]?.PERSONAL_FIELDS?.[channel] ?? EMPTY_FIELDS;
    },
    [channel],
  );

  return useApiResource(load, EMPTY_FIELDS, 'Erreur chargement champs personnalisés');
};

export default useGetPersonalFields;
